import React, { Component, PropsWithChildren } from 'react';
import VoxxifyLogo from 'assets/images/voxxify-logo.png';

import './error-boundary.style.scss';

interface IErrorBoundaryState {
	hasError: boolean;
}

export class ErrorBoundary extends Component<
	PropsWithChildren<{}>,
	IErrorBoundaryState
> {
	constructor(props: PropsWithChildren<{}>) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error: Error) {
		console.warn(`> ErrorBoundary: Application UI failed: `, error);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="error-wrapper">
					<h3 className="error-text">
						Something went wrong. Please try again or contact your system
						administrator.
					</h3>
					<img className="voxxify-logo" src={VoxxifyLogo} alt="Voxxify Logo" />
				</div>
			);
		}

		return this.props.children;
	}
}
